<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card title="유해위험기계기구 기본정보" :collapsed="true" class="cardClassDetailInfo">
        <template slot="card-detail">
          <div v-if="equipInfo.emplacementPlace" class="col-4">
            <c-label-text title="설비위치" :value="equipInfo.emplacementPlace"></c-label-text>
          </div>
          <div v-if="equipInfo.machineryClassification" class="col-4">
            <c-label-text title="설비종류" :value="equipInfo.machineryClassification"></c-label-text>
          </div>
          <div v-if="equipInfo.machineryName" class="col-4">
            <c-label-text title="형식(규격)" :value="equipInfo.machineryName"></c-label-text>
          </div>
        </template>
      </c-card>
      <c-table
        ref="table"
        title="유해위험기계기구 검사이력"
        tableId="hazardEquipmentHis"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="tabParam.hazardEquipmentHistoryModels"
        :usePaging="false"
        :editable="editable"
        :checkClickFlag="false"
        :merge="grid.merge"
        selection="multiple"
        rowKey="inspectionId"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable" label="추가" :showLoading="false"  icon="add" @btnClicked="addItem" />
            <c-btn v-if="editable && tabParam.hazardEquipmentHistoryModels.length > 0" label="삭제" :showLoading="false" icon="remove" @btnClicked="removeItem" />
            <c-btn
              v-if="editable && tabParam.hazardEquipmentHistoryModels.length > 0"
              :url="insertUrl"
              :isSubmit="isSave"
              :param="tabParam.hazardEquipmentHistoryModels"
              mappingType="POST"
              label="저장"
              icon="save"
              @beforeAction="saveHistory"
              @btnCallback="saveCallback" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>
<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'hazard-equipment-history',
  props: {
    tabParam: {
      type: Object,
      default: () => ({
        hhmHazardousMachineryId: '',
        hazardEquipmentHistoryModels: []
      }),
    },
  },
  data() {
    return {
      editable: true,
      equipInfo: {
        machineryClassificationName: '',
        machineryName: '',
        emplacementPlace: '',
      },
      grid: {
        columns: [
          {
            name: "certificateNo",
            field: "certificateNo",
            label: "안전검사번호",
            style: 'width:150px',
            align: "center",
            type: 'text',
            sortable: false,
          },
          {
            required: true,
            name: "inspectionDate",
            field: "inspectionDate",
            label: "안전검사일",
            style: 'width:100px',
            align: "center",
            type: 'date',
            sortable: false,
          },
          {
            name: 'certificateFlag',
            field: 'certificateFlag',
            label: '인증서 유무',
            align: 'center',
            style: 'width:70px',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
          },
          {
            name: 'remark',
            field: 'remark',
            label: '비고',
            align: 'center',
            style: 'width:300px',
            type: 'textarea',
            sortable: false,
          },
          {
            name: 'attach',
            field: 'attach',
            label: '첨부파일',
            align: 'center',
            style: 'width:200px',
            type: 'attach',
            taskClassCd: 'HAZARD_EQUIPMENT',
            keyText: 'inspectionId',
            sortable: false,
          },
        ],
        height: '600px',
        data: [],
      },
      isSave: false,
      checkCdItems: [], // 검사결과
      getUrl: '',
      getStdUrl: '',
      insertUrl: '',
      deleteUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    Object.assign(this.$data, this.$options.data());
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.insertUrl = transactionConfig.sop.hhm.hazard.hazardHistory.insert.url;
      this.deleteUrl = transactionConfig.sop.hhm.hazard.hazardHistory.delete.url;
      this.getStdUrl = selectConfig.sop.hhm.hazard.check.get.url;
      this.getUrl = selectConfig.sop.hhm.hazard.hazardHistory.get.url;
      this.getStandardInfo();
      // this.getDetail();
    },
    getStandardInfo() {
      if (this.tabParam.hhmHazardousMachineryId) {
        this.$http.url = this.$format(this.getStdUrl, this.tabParam.hhmHazardousMachineryId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.equipInfo = this.$_.clone(_result.data);
          this.updateMode = true;
        },);
      }
    },
    getDetail() {
      if (this.tabParam.hhmHazardousMachineryId) {
        this.$http.url = this.$format(this.getUrl, this.tabParam.hhmHazardousMachineryId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.tabParam.hazardEquipmentHistoryModels = _result.data;
        },);
      }
    },
    addItem() {
      this.tabParam.hazardEquipmentHistoryModels.splice(0, 0, {
        hhmHazardousMachineryId: this.tabParam.hhmHazardousMachineryId,
        inspectionId: uid(),
        inspectionDate: '',
        certificateNo: '',
        remark: '',
        certificateFlag: 'N',
        editFlag: 'C',
      })
    },
    removeItem() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl;
          this.$http.type = 'DELETE';
          this.$http.param = {
            data: Object.values(selectData)
          }
          this.$http.request(() => {
            this.$_.forEach(selectData, item => {
              this.tabParam.hazardEquipmentHistoryModels = this.$_.reject(this.tabParam.hazardEquipmentHistoryModels, { hhmHazardousMachineryId: item.hhmHazardousMachineryId })
            })
            this.getDetail();
            window.getApp.$emit('APP_REQUEST_SUCCESS');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      }
    },
    saveHistory() {
      let isConti = true;
      let checkItem = ['inspectionDate']
      this.$_.forEach(this.tabParam.hazardEquipmentHistoryModels, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [인증(검사)일]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave = !this.isSave;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } 
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
  }
};
</script>